class PostSelection {
  constructor(product, defaultVariant) {
    this.product = product;
    this.defaultVariant = defaultVariant;
    this.selectedVariant = this.defaultVariant;
    this.atcBtns = document.querySelectorAll(".post-selection__atc-btn");
    this.checkoutBtn = document.querySelector(".post-selection__checkout-btn");
    this.infoContent = document.querySelector(".post-selection__info-content");
    this.itemsContainer = document.querySelector(".post-selection__items-container");
    this.variantOptions = document.querySelectorAll(".post-selection__variants-container input[type='radio']");
    this.variantOptionsCross = document.querySelectorAll(".post-selection__variants-cross input[type='radio']");
    this.upsellOptions = document.querySelectorAll(".post-selection__item input[type='checkbox']");
    this.overview = document.querySelector(".post-selection__overview");
    this.overviewList = document.querySelector(".post-selection__overview-list");
    this.overviewBtn = document.querySelector(".post-selection__overview-btn");
    this.insuranceInfoBtn = document.querySelector(".post-selection__insurance-info");
    this.infoBackBtn = document.querySelector(".post-selection__back-info");
    this.addAllBtn = document.querySelector("[data-add-all]");
    
    this._init();
    this.drawerShow = true;
    this.drawerOpened = false;
  }

  _init() {
    this._microModal();
    this._splide();
    this._showAllContent();
    this._events();
    this._updateInsuranceVisibility();
    const mainItem = this._getSelectedVariant();
    // const isMounted = mainItem.options.includes("Gemonteerd");
    // this._updateInsuranceShields(isMounted);
  }

  _updateInsuranceVisibility() {
    const insuranceElement = document.querySelector('[data-insurance="true"]');
    if (!insuranceElement) return;

    const eigenTerreinInput = document.querySelector('#snelheid-eigen-terrein-60-km-u');
    const shouldHide = eigenTerreinInput && eigenTerreinInput.checked;

    insuranceElement.style.display = shouldHide ? 'none' : '';
  }


  _showAllContent() {
    // Show all content sections at once
    document.querySelectorAll("[data-page]").forEach((item) => {
      item.style.display = "block";
    });
    
    // Show all category containers
    document.querySelectorAll(".post-selection__items-category").forEach((category) => {
      category.style.display = "block";
    });
    
    // Show cross-sale and services sections
    document.querySelectorAll(".post-selection__cross-sale, .post-selection__services").forEach((section) => {
      section.style.display = "block";
    });
    
    // Show summary and items container
    document.querySelector(".post-selection__summary").style.display = "flex";
    document.querySelector(".post-selection__items-container").style.display = "flex";
    
    // Show only checkout button, hide navigation buttons
    this._updateSingleStepButtons();
  }

  _updateSingleStepButtons() {
    // Hide navigation buttons (back, next)
    const backBtn = document.querySelector(".post-selection__back-btn");
    const nextBtn = document.querySelector(".post-selection__next-btn");
    const infoBackBtn = document.querySelector(".post-selection__back-info");
    
    if (backBtn) backBtn.style.display = "none";
    if (nextBtn) nextBtn.style.display = "none";
    if (infoBackBtn) infoBackBtn.style.display = "none";
    
    // Show close button and checkout button
    const shoppingBtn = document.querySelector(".post-selection__shopping-btn");
    if (shoppingBtn) shoppingBtn.style.display = "block";
    
    if (this.checkoutBtn) {
      this.checkoutBtn.style.display = "flex";
    }
    
    // Show overview
    if (this.overview) {
      this.overview.style.display = "block";
    }
  }

  _splide() {
    new Splide(".splide", {
      type: "loop",
      perPage: 1,
      pagination: false,
      interval: 3000,
      speed: 800,
      autoplay: true,
      cover: false,
    }).mount();
  }

  _microModal() {
    this.microModalOptions = {
      openTrigger: "data-micromodal-open",
      closeTrigger: "data-micromodal-close",
      openClass: "is-open",
      disableScroll: true,
      disableFocus: false,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      debugMode: false,
    };
    MicroModal.init(this.microModalOptions);

    const modal = document.querySelector(".modal");
    const section = modal.closest(".section");

    if (modal && section) {
      section.appendChild(modal);
    }
  }

  _events() {
    this.atcBtns.forEach((btn) =>
      btn.addEventListener("click", () => {
        this._handleATCBtn();
      })
    );

    this.checkoutBtn.addEventListener("click", () => {
      this._handleCheckoutBtn();
    });

    this.upsellOptions.forEach((input) => {
      input.addEventListener("change", (e) => {
        if (input.dataset.cross === "false") {
          this._updatePrices();
          this._updateOverview();
          this._checkInsuranceItems();
          this._checkCrossVariant();
          this._checkServices(e);
        } else {
          this._checkUpsellBasedOnCross(input);
        }
      });
    });

    // Event delegation for the close button
    this.overviewList.addEventListener("click", (e) => {
      const closeBtn = e.target.closest(".post-selection__overview-item-close");
      if (closeBtn) {
        this._removeListItem(closeBtn.closest("li").dataset.variant);
      }
    });

    this.overviewBtn.addEventListener("click", (e) => {
      this.overviewBtn.classList.toggle("active");
    });

    this.insuranceInfoBtn.addEventListener("click", (e) => {
      this._showInsuranceInfo();
    });

    this.infoBackBtn.addEventListener("click", (e) => {
      this._hideInsuranceInfo();
    });

    this.variantOptions.forEach((input) => {
      input.addEventListener("change", (e) => {
        let previousVariant = this.selectedVariant;

        this.selectedVariant = this._getSelectedVariant().id;
        this._updateURL();
        this._updatePrices();
        this._updateSelectedVariantText(e);
        this._updateOverview();
        this._updateInsuranceNote(e);
        this._checkInsuranceItems();
        this._updateDelivery();
        this._updateCrossVariants(e);
        this._checkCrossVariant();
        this._updateInsuranceVisibility();
      });
    });

    this.variantOptionsCross.forEach((input) => {
      input.addEventListener("change", (e) => {
        const selectedValue = e.target.value.replace("-cross", "");
        const optionToClick = [...this.variantOptions]
          .filter((input) => input.value === selectedValue)
          .pop();

        optionToClick.click();
      });
    });

    this.addAllBtn.addEventListener("click", (e) => {
      this._handleAddAllBtn();
    });
  }

  _isElementVisible(element) {
    if (!element) return false;
    
    const computedStyle = window.getComputedStyle(element);
    return computedStyle.display !== 'none' && 
           computedStyle.visibility !== 'hidden' && 
           element.offsetParent !== null;
  }

  _handleAddAllBtn() {
    const allItems = document.querySelectorAll(".post-selection__cross-sale .post-selection__item input[type='checkbox']");
    const visibleItems = Array.from(allItems).filter(item => {
      const itemElement = item.closest('.post-selection__item');
      return this._isElementVisible(itemElement);
    });
    
    visibleItems.forEach((item) => {
      item.click();
    });
     document.querySelector('.post-selection__items-category[data-insurance="true"] input')?document.querySelector('.post-selection__items-category[data-insurance="true"] input').click():false;
  }

  _showInsuranceInfo() {
    // Hide main content and show insurance info
    document.querySelector(".post-selection__summary").style.display = "none";
    document.querySelector(".post-selection__items-container").style.display = "none";
    document.querySelector(".post-selection__variants-container").style.display = "none";
    
    // Show insurance info section
    const insuranceInfo = document.querySelector(".post-selection__insurance-info-section");
    if (insuranceInfo) {
      insuranceInfo.style.display = "block";
    }
    
    // Show back button
    if (this.infoBackBtn) {
      this.infoBackBtn.style.display = "flex";
    }
    
    // Hide checkout button temporarily
    if (this.checkoutBtn) {
      this.checkoutBtn.style.display = "none";
    }
  }

  _hideInsuranceInfo() {
    // Show main content again
    document.querySelector(".post-selection__summary").style.display = "flex";
    document.querySelector(".post-selection__items-container").style.display = "flex";
    document.querySelector(".post-selection__variants-container").style.display = "block";
    
    // Hide insurance info section
    const insuranceInfo = document.querySelector(".post-selection__insurance-info-section");
    if (insuranceInfo) {
      insuranceInfo.style.display = "none";
    }
    
    // Hide back button
    if (this.infoBackBtn) {
      this.infoBackBtn.style.display = "none";
    }
    
    // Show checkout button again
    if (this.checkoutBtn) {
      this.checkoutBtn.style.display = "flex";
    }
  }

  _checkUpsellBasedOnCross(input) {
    const targetValue = input.id.replace("variant-", "").replace("-cross", "");
    const targetUpsell = document.querySelector(
      `.post-selection__item input[value='${targetValue}']`
    );
    if (targetUpsell) {
      input.checked = false;
      targetUpsell.click();
    }
  }

  _checkServices(e) {
    const item = e.target.closest(".post-selection__item");
    const isService = item.dataset.service === "true";
    if (isService) {
      const selectedService = e.target.value;
      const serviceItems = document.querySelectorAll(
        '.post-selection__item[data-service="true"] input[type="checkbox"]'
      );

      serviceItems.forEach((serviceItem) => {
        if (serviceItem !== e.target) {
          serviceItem.checked = false;
        }
      });

      this._updateOverview();
      this._updatePrices();
    }
  }

  _checkCrossVariant() {
    const selectedUpsells = this._getUpsellItems();
    const mainItem = this._getSelectedVariant();

    // const isMounted = mainItem.options.includes("Gemonteerd");
    const isArtLock = selectedUpsells.some((item) =>
      item.title.toLowerCase().includes("art")
    );
    const isLoqater = selectedUpsells.some((item) =>
      item.title.toLowerCase().includes("loqater")
    );

    const crossSaleSection = document.querySelector(".post-selection__cross-sale");
    if (crossSaleSection) {
      crossSaleSection.style.display =
       isArtLock && isLoqater ? "none" : "flex";

      const displayStyle = (condition) => (condition ? "none" : "block");
      const optionElement = crossSaleSection.querySelector(".post-selection__option");
    //   if (optionElement) {
    //     optionElement.style.display = displayStyle(isMounted);
    //   }
      
      const lockItem = crossSaleSection.querySelector(".post-selection__item input[name='categorie_sloten']");
      if (lockItem) {
        lockItem.closest(".post-selection__item").style.display = displayStyle(isArtLock);
      }
      
      const gpsItem = crossSaleSection.querySelector(".post-selection__item input[name='categorie_gps']");
      if (gpsItem) {
        gpsItem.closest(".post-selection__item").style.display = displayStyle(isLoqater);
      }
    }
  }

  _updateCrossVariants(e) {
    const selectedCrossOption = [...this.variantOptionsCross].find(
      (input) => input.value === `${e.target.value}-cross`
    );
    if (selectedCrossOption) {
      selectedCrossOption.click();
    }
  }

  _updateDelivery() {
    const variantInventory = document.querySelector(
      ".post-selection__inventory variant-inventory"
    );

    if (variantInventory) {
      const variants = variantInventory.querySelectorAll("[data-variant-id]");

      variants.forEach((variant) => {
        variant.setAttribute("hidden", "");
      });
      variants.forEach((variant) => {
        if (+variant.dataset.variantId === this.selectedVariant) {
          variant.removeAttribute("hidden");
        }
      });
    }
  }

  _handleATCBtn() {
    MicroModal.show("modal-1", this.microModalOptions);
  }

  _handleCheckoutBtn() {
    this.checkoutBtn.querySelector(".post-selection__checkout-btn-inner").style.display = "none";
    this.checkoutBtn.querySelector(".post-selection__btn-loader").style.display = "flex";

    const mainItem = [
      {
        id: this.selectedVariant,
        quantity: 1,
      },
    ];

    this._addVariantsToCart(mainItem, () => {
      this._handleUpsellItems();
    });
  }

  _handleUpsellItems() {
    const upsellItems = this._getUpsellItems().map((item) => {
      return {
        id: item.id,
        quantity: item.quantity,
      };
    });

    if (upsellItems.length > 0) {
      const upsellItemsWithoutIncluded = upsellItems
        .filter((item) => item.id !== 0)
        .reduce((acc, item) => {
          const idExists = acc.some((i) => i.id === item.id);
          if (!idExists) {
            acc.push(item);
          }
          return acc;
        }, []);

      this._addVariantsToCart(upsellItemsWithoutIncluded, () => {
        this.drawerShow ? false : (window.location.href = "/cart");
      });
    } else {
      this.drawerShow ? false : (window.location.href = "/cart");
    }
  }

  _getSelectedVariant() {
    const selectedOptions = [];
    const selected = document.querySelectorAll(
      ".post-selection__variants-container input[type='radio']:checked"
    );

    selected.forEach((input) => {
      const optionValue = input.value;
      selectedOptions.push(optionValue);
    });

    const matchedVariant = this.product.variants.find((variant) =>
      selectedOptions.every((optionValue) =>
        variant.options.includes(optionValue)
      )
    );

    return matchedVariant;
  }

  _getUpsellItems() {
    const items = document.querySelectorAll(
      '.post-selection__items-container input[type="checkbox"]:checked'
    );

    const itemsArray = Array.from(items).filter(
      (item) => item.dataset.cross === "false"
    );

    const itemsToAdd = itemsArray.map((item) => {
      return {
        id: +item.value,
        quantity: 1,
        title: item.dataset.title,
        img: item.dataset.img,
        price: item.dataset.price,
      };
    });

    return itemsToAdd;
  }

  _updateHeaderCounter() {
    fetch(window.Shopify.routes.root + "?sections=header")
      .then((res) => res.json())
      .then((htmlString) => {
        const parser = new DOMParser();
        const header = parser.parseFromString(htmlString.header, "text/html");
        const cartCount = header.querySelector(".header__cart-count");
        document.querySelector(".header__cart-count").replaceWith(cartCount);
      });
  }

  _updateSelectedVariantText(e) {
    const container = document.querySelector(".post-selection__variants-container");
    if (!container) return;

    const optionDivs = container.querySelectorAll(".post-selection__option");

    if (optionDivs.length <= 1) {
      const selectedOption = e.target
        .closest(".post-selection__option")
        ?.querySelector(".post-selection__selected-option");
      if (selectedOption) {
        selectedOption.textContent = e.target.value;
      }
      return;
    }

    const selectedOption = container.querySelector(".post-selection__selected-option");
    if (!selectedOption) return;

    const values = [];
    optionDivs.forEach((optDiv) => {
      const checked = optDiv.querySelector("input[type='radio']:checked");
      if (checked) values.push(checked.value);
    });

    selectedOption.textContent = "";
    if (values.length > 0) {
      selectedOption.appendChild(document.createTextNode(values[0]));
    }
    if (values.length > 1) {
      selectedOption.appendChild(document.createElement("br"));
      selectedOption.appendChild(document.createTextNode(values.slice(1).join(" ")));
    }
  }

  _updatePrices() {
    const matchedVariant = this.product.variants.find(
      (variant) => variant.id === this.selectedVariant
    );
    
    const comparePrice = document.querySelector(".post-selection__compare-price");
    const totalPrice = document.querySelector(".post-selection__total-price");
    const upsellItems = this._getUpsellItems();
    const totalUpsellPrice = upsellItems
      .filter((item) => item.id !== 0)
      .reduce((acc, item) => {
        const idExists = acc.some((i) => i.id === item.id);
        if (!idExists) {
          acc.push(item);
        }
        return acc;
      }, [])
      .reduce((acc, item) => {
        return acc + +item.price;
      }, 0);
      
    if (comparePrice) {
      comparePrice.textContent = this._formatPrice(
        matchedVariant.compare_at_price + totalUpsellPrice
      );
    }
    if (totalPrice) {
      totalPrice.textContent = this._formatPrice(
        matchedVariant.price + totalUpsellPrice
      );
    }
    const installmentPrice = document.querySelector(".post-selection__footer .klarna-in3-price");
    if (installmentPrice) {
      installmentPrice.textContent = this._formatPrice(((matchedVariant.price + totalUpsellPrice) / 3).toFixed(0));
    }
    const spraypayPrice = document.querySelector(".post-selection__footer .spraypay-price");
    if (spraypayPrice) {
      spraypayPrice.textContent = this._formatPrice(((matchedVariant.price + totalUpsellPrice) *  0.02327).toFixed(0));
    }
  }

  _updateOverview() {
    if (!this.overviewList) return;
    
    this.overviewList.innerHTML = "";

    const selectedVariant = this.product.variants.find(
      (variant) => variant.id === this.selectedVariant
    );

    // Add main variant
    this._addItemToList(
      this.product.title,
      this._formatPrice(selectedVariant.price),
      this.product.featured_image,
      this.selectedVariant
    );

    // Add upsells
    const upsellItems = this._getUpsellItems()
      .filter((item) => item.id !== 0)
      .reduce((acc, item) => {
        const idExists = acc.some((i) => i.id === item.id);
        if (!idExists) {
          acc.push(item);
        }
        return acc;
      }, []);

    upsellItems.forEach((upsell) => {
      this._addItemToList(
        upsell.title,
        this._formatPrice(upsell.price),
        upsell.img,
        upsell.id
      );
    });
  }

  _updateInsuranceNote(e) {
    const insuranceNote = e.target
      .closest(".post-selection__option")
      .querySelector(".post-selection__insurance-note");

    if (insuranceNote) {
      const insuranceDeny = insuranceNote.querySelector(".post-selection__insurance-deny");
      const insuranceApprove = insuranceNote.querySelector(".post-selection__insurance-approve");
      
      if (e.target.value === "Gemonteerd") {
        if (insuranceDeny) insuranceDeny.style.display = "none";
        if (insuranceApprove) insuranceApprove.style.display = "flex";
        this._updateInsuranceShields(true);
      } else {
        if (insuranceDeny) insuranceDeny.style.display = "none";
        if (insuranceApprove) insuranceApprove.style.display = "flex";
        this._updateInsuranceShields(true);
      }
    }
  }

  _updateInsuranceShields(show) {
    const productShields = document.querySelectorAll(".post-selection__item-product-shield");
    productShields.forEach((shield) => {
      shield.style.display = show ? "inline-flex" : "none";
    });
  }

  _checkInsuranceItems() {
    const insuranceCat = document.querySelector('.post-selection__items-category[data-insurance="true"]');
    const insuranceNote = document.querySelector(".post-selection__insurance-note--final");

    if (!insuranceCat || !insuranceNote) return;

    const mainItem = this._getSelectedVariant();
    const upsellItems = this._getUpsellItems();
    // const isMounted = mainItem.options.includes("Gemonteerd");
    const isArtLock = upsellItems.some((item) =>
      item.title.toLowerCase().includes("art")
    );
    const isLoqater = upsellItems.some((item) =>
      item.title.toLowerCase().includes("loqater")
    );
    
    if (isArtLock && isLoqater) {
      insuranceCat.classList.remove("disabled");
      const input = insuranceCat.querySelector("input");
      if (input) {
        input.disabled = false;
        //input.click();
      }
      
      const denyElement = insuranceNote.querySelector(".post-selection__insurance-deny");
      const approveElement = insuranceNote.querySelector(".post-selection__insurance-approve");
      
      if (denyElement) denyElement.style.display = "none";
      if (approveElement) approveElement.style.display = "flex";
    } else {
      insuranceCat.classList.add("disabled");
      const input = insuranceCat.querySelector("input");
      if (input) {
        input.disabled = true;
        input.checked = false;
      }
      
      const denyElement = insuranceNote.querySelector(".post-selection__insurance-deny");
      const approveElement = insuranceNote.querySelector(".post-selection__insurance-approve");
      
      if (denyElement) denyElement.style.display = "flex";
      if (approveElement) approveElement.style.display = "none";
      
      this._updateOverview();
      this._updatePrices();
    }
  }

  _createListItem(title, price, imgSrc, variantId) {
    const template = document.getElementById("listItemTemplate");
    if (!template) return null;
    
    const clone = template.content.cloneNode(true);

    const titleElement = clone.querySelector(".post-selection__item-product-title");
    const priceElement = clone.querySelector(".post-selection__item-product-price");
    const imgElement = clone.querySelector(".post-selection__overview-img");
    const itemElement = clone.querySelector(".post-selection__overview-item");
    
    if (titleElement) titleElement.textContent = title;
    if (priceElement) priceElement.textContent = price;
    if (imgElement) imgElement.src = imgSrc;
    if (itemElement) itemElement.setAttribute("data-variant", variantId);

    return clone;
  }

  _addItemToList(title, price, imgSrc, variantId) {
    if (!this.overviewList) return;
    
    this.overviewList.style.display = "flex";
    const listItem = this._createListItem(title, price, imgSrc, variantId);
    if (listItem) {
      this.overviewList.appendChild(listItem);
    }
  }

  _removeListItem(variantId) {
    if (!this.overviewList) return;
    
    const listItem = this.overviewList.querySelector(
      `.post-selection__overview-item[data-variant='${variantId}']`
    );
    if (listItem) {
      listItem.remove();
    }
    
    const checkBoxes = document.querySelectorAll(`input#variant-${variantId}`);
    checkBoxes.forEach((checkBox) => {
      if (checkBox) {
        checkBox.checked = false;
      }
    });
    
    const checkBoxesCross = document.querySelectorAll(`input#variant-${variantId}-cross`);
    checkBoxesCross.forEach((checkBox) => {
      if (checkBox) {
        checkBox.checked = false;
      }
    });

    if (this.overviewList.children.length === 0) {
      this.overviewList.style.display = "none";
    }
    
    this._updatePrices();
    this._checkInsuranceItems();
    this._checkCrossVariant();
  }

  _formatPrice(priceInCents) {
    // let price = priceInCents / 100;
    // price = price.toLocaleString("nl-NL", { maximumFractionDigits: 2 });
    // price = price.replace(",00", ",-");

    return this.formatMoney(priceInCents);
  }
  formatMoney(cents, format = "") {
    if (typeof cents === "string") {
        cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
        return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ",");
        decimal = defaultTo(decimal, ".");
        if (isNaN(number) || number == null) {
        return 0;
        }
        number = (number / 100).toFixed(precision);
        let parts = number.split("."),
        dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands
        ),
        centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
        case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
        case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
        case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
        case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
        case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
        case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
        case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
        return formatString.replace(placeholderRegex, value);
    } else {
        return formatString.replace(placeholderRegex, value);
    }
    }

  _updateURL() {
    const url = new URLParse(window.location.href, true);
    const newVariantValue = this.selectedVariant;
    url.query.variant = newVariantValue;
    window.history.replaceState(null, null, url.toString());
  }

  _getCart() {
    return fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }).then((response) => response.json());
  }

  _addVariantsToCart(items, cb = null) {
    const drawerId = document
      .querySelector("cart-drawer")
      .parentElement.id.replace("shopify-section-", "");
      
    let str = "";
    items.length > 0 ? (this.drawerOpened = true) : (this.drawerOpened = false);
    items.length > 0 ? (str = `/variants/${items[0].id}`) : false;
    
    let formData = {
      items: items,
      sections: `variant-added,${drawerId}`,
      sections_url: str,
    };
    
    if (this.drawerShow) {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: ["variant-added"] },
        })
      );
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        this.drawerShow && this.drawerOpened
          ? this._openDrawer(responseJson)
          : false;
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        if (cb) {
          cb();
        }
        this.drawerShow ? this._closeModal() : false;
      });
  }

  async _openDrawer(responseJson) {
    const cartContent = await (await fetch(`/cart.js`)).json();
    cartContent["sections"] = responseJson["sections"];
    document.documentElement.dispatchEvent(
      new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items")
            ? responseJson["items"]
            : [responseJson],
          cart: cartContent,
        },
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent,
        },
      })
    );
  }

  _closeModal() {
    document
      .querySelector(".micromodal-slide [data-micromodal-close] ")
      .click();
    this.checkoutBtn.querySelector(".post-selection__checkout-btn-inner").style.display = "flex";
    this.checkoutBtn.querySelector(".post-selection__btn-loader").style.display = "none";
  }

  _removeVariantsFromCart(variantToRemove, cb = null) {
    let updates = {
      [variantToRemove]: 0,
    };
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        if (cb) {
          cb();
        }
      });
  }
}